/**
 * @name IPositionBreakSettingsREST
 * @type string | null - JSON String
 *
 * @docs https://docs.busybusy.xyz/v3-api/3.76.0-beta8/#tag/Position/paths/~1position/post *
 */
export type IPositionBreakSettingsREST = string | null; // JSON

export const POSITION_BREAK_SETTINGS_TYPE_DEFAULT = 'default' as const;
export const POSITION_BREAK_SETTINGS_TYPE_INTERVAL = 'interval' as const;
export const POSITION_BREAK_SETTINGS_TYPE_STATIC = 'static' as const;
export const POSITION_BREAK_SETTINGS_TYPE_MINIMUM = 'minimum' as const;

export const POSITION_BREAK_SETTINGS_TYPES = [
  POSITION_BREAK_SETTINGS_TYPE_DEFAULT,
  POSITION_BREAK_SETTINGS_TYPE_INTERVAL,
  POSITION_BREAK_SETTINGS_TYPE_STATIC,
  POSITION_BREAK_SETTINGS_TYPE_MINIMUM,
] as const;

export const POSITION_BREAK_SETTINGS_TYPES_AUTOMATIC = [
  POSITION_BREAK_SETTINGS_TYPE_INTERVAL,
  POSITION_BREAK_SETTINGS_TYPE_STATIC,
] as const;

export type TPositionBreakSettingsType = (typeof POSITION_BREAK_SETTINGS_TYPES)[number];
export type TPositionBreakSettingsTypeAutomatic = (typeof POSITION_BREAK_SETTINGS_TYPES_AUTOMATIC)[number];
export type TPositionBreakSettingsTypeInterval = typeof POSITION_BREAK_SETTINGS_TYPE_INTERVAL;
export type TPositionBreakSettingsTypeStatic = typeof POSITION_BREAK_SETTINGS_TYPE_STATIC;
export type TPositionBreakSettingsTypeMinimum = typeof POSITION_BREAK_SETTINGS_TYPE_MINIMUM;

/** seconds integer between 0 and 84600 with minute granularity */
export type TBreakSettingsIntSeconds = number;

export type IPositionBreakSettingsDefault = null;

export interface IPositionBreakSettingsBase {
  type: TPositionBreakSettingsType;
  duration?: unknown;
  settings?: unknown;
}
export interface IPositionBreakSettingsAutomatic extends IPositionBreakSettingsBase {
  type: TPositionBreakSettingsTypeAutomatic;
  duration?: never;
  settings: {
    offset: TBreakSettingsIntSeconds;
    duration: TBreakSettingsIntSeconds;
  }[];
}

export interface IPositionBreakSettingsInterval extends IPositionBreakSettingsAutomatic {
  type: TPositionBreakSettingsTypeInterval;
}
export interface IPositionBreakSettingsStatic extends IPositionBreakSettingsAutomatic {
  type: TPositionBreakSettingsTypeStatic;
}

export interface IPositionBreakSettingsMinimum extends IPositionBreakSettingsBase {
  type: TPositionBreakSettingsTypeMinimum;
  duration: TBreakSettingsIntSeconds;
  settings?: never;
}

export type IPositionBreakSettings =
  | IPositionBreakSettingsDefault
  | IPositionBreakSettingsInterval
  | IPositionBreakSettingsStatic
  | IPositionBreakSettingsMinimum;
